<template>
  <Menu :active-name="activeIndex" :open-names="openeds" theme="light" width="auto" @on-select="go">
    <template v-for="(item,index) in menus">
      <template v-if="item.children&&item.children.length>0">
        <sideBarItem :menu="item"></sideBarItem>
      </template>
      <template v-else>
        <MenuItem :name="item.name">
        <i v-if='item.icon' :class="item.icon"></i>
        <span>{{item.text}}</span>
        </MenuItem>
      </template>
    </template>
  </Menu>
</template>

<script>
import sideBarItem from "./sideBarItem";

export default {
  components: { sideBarItem },
  data() {
    return {
      openeds: [],
      menus: [],
      activeIndex: ""
    };
  },
  created: function() {
    this.activeIndex = this.$route.name;
    this.openeds =
      this.$route.matched
        .slice(1, this.$route.matched.length - 1)
        .map(t => t.name) || [];

    let route = this.$app.router.findRoute(
      this.$app.menus,
      this.$route.matched[0].name
    );
    if (route && route.children) {
      this.menus = route.children;

      const expandNames = this.$app.router
        .findBy(route.children, t => t.expand === true)
        .map(t => t.name);
      expandNames.forEach(t => {
        if (this.openeds.indexOf(t) === -1) this.openeds.push(t);
      });
    }
  },
  methods: {
    go(name) {
      if (this.$route.name != name) this.$router.push({ name });
    }
  }
};
</script>